module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('div', {
    class: (_vm.isHeightAuto ? 'height-auto ' : '') + ' loader-wrapper'
  }, [_c('div', {
    staticClass: "md-preloader"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "height": _vm.height,
      "width": _vm.width,
      "viewbox": _vm.viewbox
    }
  }, [_c('circle', {
    attrs: {
      "cx": _vm.cx,
      "cy": _vm.cy,
      "r": _vm.r,
      "stroke-width": "4",
      "stroke": _vm.color
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcf23e36"}!./src/app/components/loading/loading.html
// module id = 1444
// module chunks = 0